"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Badge } from "@/components/ui/badge";
export default function PortfolioIntroduction() {
  const {
    ref: badgeRef,
    isVisible: badgeVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: paragraphRef,
    isVisible: paragraphVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section id="portfolio-introduction" className="bg-primary ![padding:90px_24px_0px_24px]">
      <div className="mx-auto max-w-3xl flex flex-col items-center text-center gap-6">
        <div ref={badgeRef}>
          
        </div>

      <h2 ref={headingRef} className={`
    text-[48px] font-display font-bold
    text-foreground leading-tight
    transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]
    ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}
  `} style={{
        transitionDelay: headingVisible ? "200ms" : "0ms"
      }}>
  Luxury Renovation Projects Across Cyprus
</h2>

        <p ref={paragraphRef} className="text-foreground-primary max-w-2xl leading-relaxed transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] opacity-100 translate-y-0" style={{
        transitionDelay: paragraphVisible ? "200ms" : "0ms"
      }}>Our portfolio reflects the philosophy of <span className="font-semibold">KS LUXURY RENOVATIONS</span>, refined design, precision craftsmanship, and spaces created with intention. Each project is the result of close collaboration, thoughtful planning, and uncompromising execution.<br></br>

<br></br><strong>Selected Works<br></br></strong>
<br></br>Explore a curated collection of luxury renovations completed by <span className="font-semibold">KS LUXURY RENOVATIONS</span> across Limassol and Cyprus.
      </p>
      </div>
    </section>;
}